import { Typography, Modal, Button } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconTrash } from "../../../../utils/icons";

interface Props {
  show: boolean;
  onCancel?: () => void;
  onOkay?: () => void;
}

export function ConfirmDeleteModal({ show, onOkay, onCancel }: Props) {
  return (
    <Modal
      open={show}
      className="flex items-center justify-center p-4 sm:p-0"
      onClose={onCancel}
    >
      <div className="bg-surface py-6 rounded-xl w-full sm:w-[450px] max-w-[calc(100vw-32px)] outline-none">
        <div className="px-6 flex items-center justify-between">
          <Typography variant="h5">
            Delete product
          </Typography>
          <CloseIcon onClick={onCancel} />
        </div>
        <div className="py-4 p-6">
          <div className="font-CircularStdBlack text-text-1">
            Are you sure you want to delete this product? This action is
            irreversible.
          </div>
        </div>
        <div className="border-t border-border-token pt-4 flex items-center justify-end px-6 gap-3 flex-wrap">
          <Button className="!bg-surface-2 !py-3 !px-4" onClick={onCancel}>
            <Typography className="text-text-1 normal-case">Cancel</Typography>
          </Button>
          <Button
            className="!bg-red flex gap-2 transform-0 rounded-3 !py-3 !px-4"
            onClick={onOkay}
          >
            <IconTrash width={24} height={24} stroke="#fff" />
            <Typography className="text-white normal-case">
              Delete product
            </Typography>
          </Button>
        </div>
      </div>
    </Modal>
  );
}
